module.exports = __webpack_public_path__ + "media/components/NewAsset/icons/commercial-aa2f1b28c95819f4218f744dcd07f6ef.svg";